// Autogenerated file
export const chatTypesEnum = {
    Simple: "Simple",
    System: "System",
    BidChat: "BidChat",
    DriverChat: "DriverChat",
    DocumentFlowChat: "DocumentFlowChat",
    FixRouteBidChat: "FixRouteBidChat",
    DocumentRegistry: "DocumentRegistry",
    DriverNotifications: "DriverNotifications",
};
export const chatTypes = [
    { label: "Обычный", value: "Simple" },
    { label: "Системный", value: "System" },
    { label: "Ставка/Заявка", value: "BidChat" },
    { label: "Водитель", value: "DriverChat" },
    { label: "Чат для документооборота", value: "DocumentFlowChat" },
    { label: "Чат по заявке на корректировку маршрута", value: "FixRouteBidChat" },
    { label: "Чат реестра перевозок", value: "DocumentRegistry" },
    { label: "Чат с уведомлениями водителя", value: "DriverNotifications" },
];
